module.exports = __webpack_public_path__ + "media/images/icon_checkbox_on_40-38-cce6fd84ad51e6e09732e91c16d85977.png";